export default [
  {
    path: '/',
    name: 'index',
    component: () => import('./views/account/index'),
  },
  {
    path: '/index',
    name: 'indexe',
    component: () => import('./views/account/index'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('./views/account/login'),
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('./views/account/register'),    
  },
  {
    path: '/forgot-password',
    name: 'Forgot password',
    component: () => import('./views/account/forgot-password'),
  },
  {
    path: '/logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        localStorage.removeItem('member');
        localStorage.removeItem('phone');
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.push('/index')
        )
        next(authRequiredOnPreviousRoute ? { name: 'default' } : { ...routeFrom })
      },
    },
  },
  {
    path: '/404',
    name: '404',
    component: require('./views/utility/404').default,
  },
  {
    path: '*',
    redirect: '404',
  },
  {
    path: '/verify',
    name: 'verify',
    component: () => import('./views/account/verify')
  },
  {
    path: '/authenticate',
    name: 'authenticate',
    component: () => import('./views/account/authenticate')
  }, 
  {
    path: '/home',
    name: 'home',
    component: () => import('./views/account/home')
  },
  {
    path: '/news',
    name: 'news',
    component: () => import('./views/account/news')
  },
  {
    path: '/packages',
    name: 'packages',
    component: () => import('./views/account/packages')
  },
  
  {
    path: '/article',
    name: 'article',
    component: () => import('./views/account/article')
  },
  
  
  {
    path: '/comingsoon',
    meta: { authRequired: true },
    component: () => import('./views/dashboards/comingsoon')
  },
  {
    path: '/pages/404',
    name: 'Error-404',
    meta: { authRequired: true },
    component: () => import('./views/utility/404')
  },
  {
    path: '/pages/500',
    name: 'Error-500',
    meta: { authRequired: true },
    component: () => import('./views/utility/500')
  },   
]